import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { Loading } from '../../../../../../common/loading'
import { Notification } from '../../../../../../common/notification'
import { mapViewBy } from '../../constant'
import { selectCompareVal, selectData, selectLoading } from '../../store/slice'
import ChartSize from './ChartSize'
import TableSize from './TableSize'

const Size = ({ viewBy, isDynamicReport, settingDynamic = {} }) => {
  const loading = useSelector(selectLoading)
  const compareValStore = useSelector(selectCompareVal)
  const { compareBetweenRatio: compareValDyn } = settingDynamic
  const compareVal = isDynamicReport ? compareValDyn : compareValStore

  const data = useSelector(selectData)
  const defaultData = data[compareVal]?.defaultIndustry
  const compareData = data[compareVal]?.comparingIndustry
  const year = defaultData?.sizeYear || compareData?.sizeYear || ''

  return (
    <div style={{ position: 'relative' }}>
      <Element
        style={{
          fontSize: 14,
          fontWeight: 600,
          marginBottom: isDynamicReport ? 0 : 14,
        }}
      >
        <Translate value="companyAnalysis.industryAnalysis.SIZE" year={year} />
      </Element>
      {loading ? (
        <div className="positionRelative" style={{ height: 350 }}>
          <Loading />
        </div>
      ) : (
        <div id="sizeChartId">
          <>
            {!defaultData?.size && !compareData?.size ? (
              <div style={{ height: 350 }}>
                <Notification />
              </div>
            ) : (
              <>
                {viewBy === mapViewBy.chart.value ? (
                  <ChartSize
                    year={year}
                    isDynamicReport={isDynamicReport}
                    settingDynamic={settingDynamic}
                  />
                ) : (
                  <TableSize
                    year={year}
                    isDynamicReport={isDynamicReport}
                    settingDynamic={settingDynamic}
                  />
                )}
              </>
            )}
          </>
        </div>
      )}
    </div>
  )
}

export default Size
